<ng-container *ngIf="!isLoading; else loadingTemplate">

  <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
    <app-external-header
      [isCompanyProfile]="true"
      [isInboxPresent]="true"
      [isMobile]="isMobile"
      [isProfile]="false"
      [showButtons]="false"
      [showProfilePicture]="true"
      style="width: 100%; z-index: 1000; position: relative;"
    ></app-external-header>
  </div>

  <div class="page-content overview-container">
    <div class="overview-left">
      <div class="job-description-box">
        <h2 class="overview-title">
          {{ isEditMode ? ('job_details.sidebar.edit' | translate) : ('job_details.sidebar.create' | translate) }}
        </h2>
        <div class="overview-subtitle">{{ 'job_details.sidebar.job_description' | translate }}</div>

        <div class="form-section">
          <div class="input-wrapper">
            <app-input
              [formControl]="titleFormControl"
              [label]="'job_details.occupation_title' | translate"
              [placeholder]="'job_details.placeholder.title' | translate"
              [showLabel]="true"
              [size]="InputSize.LARGER"
              [state]="InputState.REGULAR"
              [type]="'text'"
              [withNoIcon]="true">
            </app-input>
            <mat-error *ngIf="isInvalidAndTouched(titleFormControl)">
              {{ 'job_details.title_required' | translate }}
            </mat-error>
          </div>


          <div class="input-wrapper" style="margin-top: 1rem;">
            <label class="label-text">{{ 'options.description' | translate }}</label>
            <app-input-area
              (text)="onDescriptionChange($event)"
              [defaultText]="this.job.description"
              [isEditable]="true"
              [withSubmit]="false">
            </app-input-area>


            <mat-error *ngIf="isInvalidAndTouched(descriptionFormControl)">
              {{ 'job_details.description_required' | translate }}
            </mat-error>
          </div>

          <div class="input-wrapper" style="margin-top: 1rem;">
            <label class="label-text">{{ 'options.qualifications' | translate }}</label>
            <app-input-area
              (text)="onQualificationsChange($event)"
              [defaultText]="this.job.description"
              [isEditable]="true"
              [withSubmit]="false">
            </app-input-area>


            <mat-error *ngIf="isInvalidAndTouched(descriptionFormControl)">
              {{ 'job_details.description_required' | translate }}
            </mat-error>
          </div>
        </div>

        <div class="form-section two-columns">
          <div class="input-wrapper">
            <app-input
              [formControl]="locationFormControl"
              [label]="'job_details.sidebar.location' | translate"
              [placeholder]="'job_details.placeholder.location' | translate"
              [showLabel]="true"
              [size]="InputSize.LARGER"
              [state]="InputState.REGULAR"
              [type]="'text'"
              [withNoIcon]="true">
            </app-input>

            <mat-error *ngIf="isInvalidAndTouched(locationFormControl)">
              {{ 'job_details.location_required' | translate }}
            </mat-error>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="overview-subtitle">{{ 'job_details.sidebar.compensation' | translate }}</div>
        <div class="form-section">
          <label class="label-text">{{ 'job_details.sidebar.salary' | translate }}</label>
          <app-dropdown
            [clearable]="false"
            [formControl]="salaryRangeCtrl"
            [items]="salaryRanges"
            [multiple]="false"
            placeholder="{{ 'job_details.sidebar.salary' | translate }}"
          >
            <ng-template #optionTpl let-salary>
              <div class="option"><span>{{ salary }}</span></div>
            </ng-template>

            <ng-template #selectedItemTpl let-salary>
              <div class="selected-item"><span>{{ salary }}</span></div>
            </ng-template>
          </app-dropdown>
        </div>

        <mat-divider></mat-divider>

        <div class="overview-subtitle">{{ 'job_details.sidebar.languages' | translate }}</div>
        <div class="form-section">

          <label class="label-text">{{ 'job_details.sidebar.german_level' | translate }}</label>
          <app-dropdown
            [clearable]="false"
            [formControl]="languageLevelCtrl"
            [items]="germanLevels"
            [multiple]="false"
            placeholder="{{ 'job_details.sidebar.language' | translate }}"
          >
            <ng-template #optionTpl let-level>
              <div class="option"><span>{{ level }}</span></div>
            </ng-template>

            <ng-template #selectedItemTpl let-level>
              <div class="selected-item"><span>{{ level }}</span></div>
            </ng-template>
          </app-dropdown>
        </div>

        <mat-divider></mat-divider>

        <div class="overview-subtitle">{{ 'job_details.candidate' | translate }}</div>
        <div class="form-section two-columns">

          <label class="label-text">{{ 'job_details.sidebar.experience' | translate }}</label>
          <app-dropdown
            [clearable]="false"
            [formControl]="experienceCtrl"
            [items]="experiences"
            [multiple]="false"
            placeholder="{{ 'job_details.sidebar.experience' | translate }}"
          >
            <ng-template #optionTpl let-exp>
              <div class="option"><span>{{ exp }}</span></div>
            </ng-template>

            <ng-template #selectedItemTpl let-exp>
              <div class="selected-item"><span>{{ exp }}</span></div>
            </ng-template>
          </app-dropdown>


          <label class="label-text">{{ 'job_details.sidebar.education_level' | translate }}</label>
          <app-dropdown
            [clearable]="false"
            [formControl]="educationCtrl"
            [items]="educationLevels"
            [multiple]="false"
            placeholder="{{ 'job_details.sidebar.education_level' | translate }}"
          >
            <ng-template #optionTpl let-edu>
              <div class="option"><span>{{ edu }}</span></div>
            </ng-template>

            <ng-template #selectedItemTpl let-edu>
              <div class="selected-item"><span>{{ edu }}</span></div>
            </ng-template>
          </app-dropdown>
        </div>
      </div>
    </div>

    <!-- Right Side -->
    <div class="overview-right">
      <div class="sidebar-card">
        <div class="overview-subtitle">{{ 'job_details.sidebar.post_job' | translate }}</div>

        <div class="form-section">
          <div class="input-wrapper">
            <app-input
              [formControl]="endDateFormControl"
              [icon]="'assets/icons/calendar.svg'"
              [label]="'job_details.end' | translate"
              [min]="today"
              [showLabel]="true"
              [size]="InputSize.LARGER"
              [state]="InputState.REGULAR"
              [type]="'date'"
              [withNoIcon]="false">
            </app-input>

            <mat-error *ngIf="isInvalidAndTouched(endDateFormControl)">
              {{ 'job_details.end_date_required' | translate }}
            </mat-error>
          </div>
        </div>

        <app-button
          (click)="submitJobOffer()"
          [label]="isEditMode ? ('job_details.sidebar.edit_button' | translate) : ('job_details.sidebar.create_button' | translate)"
          [size]="ButtonSize.LARGE"
          [state]="isSubmitDisabled() ? ButtonState.DISABLED : ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY"
          class="submit-button">
        </app-button>
      </div>
    </div>
  </div>
</ng-container>

<div class="footer-class footer-container">
  <app-footer></app-footer>
</div>

<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
